





























import { DynamicDocumentItem, InstallationModuleData } from '@/types';
import { sortNumbers } from '@/utilities/sort';

import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
  },

  data() {
    return {
      menu: {
        closeOnContentClick: true,
        closeOnClick: true,
      },
    };
  },

  computed: {
    columns(): any[] {
      return new Array(10)
        .fill(null)
        .map((d, i) => ({ text: i + 1, value: i + 1, disabled: i + 1 < this.minCols }));
    },

    rows(): any[] {
      return new Array(10)
        .fill(null)
        .map((d, i) => ({ text: i + 1, value: i + 1, disabled: i + 1 < this.minRows }));
    },

    minCols(): number {
      const colMax =
        (this.moduleData.grid
          ?.map(cell => cell.col)
          .sort(sortNumbers)
          .reverse()[0] ?? 0) + 1;

      return Math.max(colMax, Math.ceil(this.moduleData.numberOfPanels! / this.moduleData.rows!));
    },

    minRows(): number {
      const rowMax =
        (this.moduleData.grid
          ?.map(cell => cell.row)
          .sort(sortNumbers)
          .reverse()[0] ?? 0) + 1;

      return Math.max(
        rowMax,
        Math.ceil(this.moduleData.numberOfPanels! / this.moduleData.panelsPerRow!),
      );
    },
  },

  methods: {
    save() {
      this.$emit('save:module');
    },
  },
});
